"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;
var _default = {
  '@charset': 'UTF-8',
  '@font-face': {
    fontFamily: 'icon-fonts',
    src: "\n        url(\"/assets/fonts/icon-fonts.eot?#iefix\") format(\"embedded-opentype\"),\n        url(\"/assets/fonts/icon-fonts.ttf\") format(\"truetype\"),\n        url(\"/assets/fonts/icon-fonts.svg#icon-fonts\") format(\"svg\"),\n        url(\"/assets/fonts/icon-fonts.woff\") format(\"woff\"),\n        url(\"/assets/fonts/icon-fonts.woff2\") format(\"woff2\")",
    fallbacks: [{
      src: "url(\"/assets/fonts/icon-fonts.eot\")"
    } // { src: `url("/assets/fonts/icon-fonts.eot?#iefix") format("embedded-opentype")` },
    // { src: `url("/assets/fonts/icon-fonts.ttf") format("truetype")` },
    // { src: `url("/assets/fonts/icon-fonts.svg#icon-fonts") format("svg")` },
    // { src: `url("/assets/fonts/icon-fonts.woff") format("woff")` },
    // { src: `url("/assets/fonts/icon-fonts.woff2") format("woff2")` },
    ],
    fontWeight: 'normal',
    fontStyle: 'normal'
  }
};
exports["default"] = _default;